import React from 'react';
import { Home, BarChart, Upload, BrightnessHigh, VideoLibrary, Publish, BrightnessLow, AccountCircle } from "@mui/icons-material";

import { useAuth } from "../../context/AuthContext";


function Sidebar() {

  
  const { user } = useAuth();
  
  //console.log('user check  vvv ', user);
  return (
    <aside className="sidebar">
    {user && user.categorie==="0" && (
      <>

      <div className="menu-item"><Home /><a href='/dashboard'>Accueil</a> </div>
      <div className="menu-item"><Upload /><a href='/upload'> Upload</a> </div>
      <div className="menu-item"><VideoLibrary /><a href='/videolist'> Convertir</a> </div>
      <div className="menu-item"><Publish /><a href='/videolist/pub'> Publier</a> </div>
      <div className="menu-item"><BrightnessLow /><a href='/video/config'> Configurer</a> </div>
      <div className="menu-item"><BarChart /><a href='/videolist/statistique'> Statistiques</a> </div>
      <div className="menu-item"><AccountCircle /><a href='/users/register'> Utilisateurs</a> </div>
      <div className="menu-item"><BrightnessHigh /><a href='#'> Paramètres</a> </div>

    </>
    )}
    
    {user && user.categorie==="1" && (
        <>

        <div className="menu-item"><Home /><a href='/dashboard'>Accueil</a> </div>
        <div className="menu-item"><BarChart /><a href='/videolist/statistique'> Statistiques</a> </div>
        <div className="menu-item"><BrightnessHigh /><a href='#'> Paramètres</a> </div>

      </>
      )}
    </aside>
  );
}

export default Sidebar;
